import { memo } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';



// Edited Functionality of re-arranging dashboard menu with two ways binding --Shuaib Peerjade 04/10/2024 ---START

const SubNav = ({ handleToggle, activeNav, arrMemoisedMenus, ...props }) => {

    const objLoginSession = useSelector(state => state.auth.objLoginSession);

    return (
        <Container fluid className='p-0 px-3 py-2 position-relative' >
            <Row className='subnav-container g-0 align-items-center' >
                <Col md={2}>
                    {/* <BzToolTip placement='bottom' TooltipMsg={objLoginSession?.data?.user_name} >
                        <div className='font-regular font-size6 color-text text-truncate'>Hi, <span className='font-medium'>{objLoginSession?.data?.user_name ? objLoginSession?.data?.user_name?.length > 1 ? objLoginSession?.data?.user_name?.slice(0, 15) + ".." : objLoginSession?.data?.user_name : ''}</span></div>
                    </BzToolTip> */}
                </Col>
                <Col md={10} className='text-end'>
                    <div className='submenu-wrapper horizontal-scroll-wrap py-1'>
                        {
                            arrMemoisedMenus?.length && arrMemoisedMenus.map((item, index) => {
                                return <a key={index} href={`#${item?.name}`} onClick={handleToggle.bind(this, item.name)}
                                    className={`submenuItem ${activeNav === item?.name ? 'active' : ''}`}>{item.displayName}</a>;
                            })
                        }
                    </div>
                </Col>
            </Row>
        </Container>
    );
};

export default memo(SubNav);

// Edited Functionality of re-arranging dashboard menu with two ways binding --Shuaib Peerjade 04/10/2024 ---END